import React, { Component } from 'react';
import {Redirect} from "react-router-dom";

class PathRederict extends Component {
    useQuery = () => {
      return new URLSearchParams(window.location.hash.split('?')[1]);
    }
    state={
      path:null,
    }
    async componentDidMount(){
      const query = this.useQuery();
      const path = query.get("path")
      console.log(`redericting to path:${path}`);
      if(path){
        this.setState({
          path
        })
      }
    }

    render(){
      if(this.state.path){
        return <Redirect to={this.state.path}/>;
      } else{
        return <div>redericting </div>;
      }
    }
  }
  export default (PathRederict)
